/* eslint-disable no-restricted-properties */
const babyNameGenerator = (function () {
	function init() {
		loadJSON(function (response) {
			// PARSE JSON STRING INTO OBJECT
			const jsonData = JSON.parse(response);
			babyNameGenerator.init(jsonData);
		});
	}

	function loadJSON(callback) {
		// VANILLA JS CALL FOR THE DATA FROM LOCAL SOURCE
		const xobj = new XMLHttpRequest();
		if (xobj.overrideMimeType) {
			xobj.overrideMimeType('application/json');
		}
		xobj.open(
			'GET',
			'https://www.confused.com/static/cmsmedia/cms-widgets/redesign/baby-name-generator/jsonData/babyNames.json',
			true
		); // SET THE FILE YOU WANT TO FETCH
		// xobj.open("GET", "../jsonData/babyNames.json", true); // SET THE FILE YOU WANT TO FETCH
		xobj.onreadystatechange = function () {
			if (xobj.readyState == 4 && xobj.status == '200') {
				// Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
				callback(xobj.responseText);
			}
		};
		xobj.send(null);
	}

	const babyNameGenerator = {
		widget: document.getElementById('cnfsd-bng-widget'),
		form: document.getElementById('cnfsd_bng'),
		nameCard: document.querySelector('.card__inner'),
		fieldGroups: null,
		potentialBabyNameList: [],
		babyNameData: null,
		babySurnameValue: null,
		checkedBabyNames: [],

		init: jsonData => {
			babyNameGenerator.babyNameData = jsonData;
			babyNameGenerator.fieldGroups = babyNameGenerator.form.querySelectorAll('.field-group');

			const suggestNameButton = babyNameGenerator.form.querySelector('button.btn.btn--arrow'),
				newButton = babyNameGenerator.nameCard.querySelector('button.btn'),
				restartButton = babyNameGenerator.nameCard.parentElement.querySelector('a.arrow-link');

			babyNameGenerator.nameCard.parentElement.style.display = 'none';

			suggestNameButton.addEventListener('click', e => {
				const offset = 72;
				const y = babyNameGenerator.widget.getBoundingClientRect().top + window.pageYOffset - offset;
				window.scrollTo({ top: y, behavior: 'smooth' });
				e.preventDefault();
				babyNameGenerator.createBabyNameList();
			});

			newButton.addEventListener('click', e => {
				e.preventDefault();
				babyNameGenerator.chooseBabyName();
			});

			restartButton.addEventListener('click', e => {
				e.preventDefault();
				babyNameGenerator.resetWidget();
			});

			babyNameGenerator.setInputEventListeners();
		},

		createBabyNameList: () => {
			const [nameStyleOptions, genderOptions, surnameFieldGroup] = babyNameGenerator.fieldGroups,
				chosenNameStyle = nameStyleOptions.querySelector('input:checked'),
				selectedGender = genderOptions.querySelector('input:checked'),
				surnameInput = surnameFieldGroup.querySelector('input');

			//IF ERRORS IN FORM
			if (!chosenNameStyle || !selectedGender || surnameInput.value.trim() === '') {
				if (!chosenNameStyle) babyNameGenerator.validateInputs(nameStyleOptions, 'bng-style-errored');
				if (!selectedGender) babyNameGenerator.validateInputs(genderOptions, 'bng-gender-errored');
				if (surnameInput.value.trim() === '')
					babyNameGenerator.validateInputs(surnameFieldGroup, 'bng-surname-errored');
				return;
			}

			babyNameGenerator.babySurnameValue = surnameInput.value;

			babyNameGenerator.potentialBabyNameList = babyNameGenerator.babyNameData.filter(item => {
				const styleMatches =
					chosenNameStyle.value === 'any' || item.style.indexOf(chosenNameStyle.value) > -1;

				let genderMatches = true;

				if (selectedGender.value === 'neutral') {
					// If 'neutral' is selected, we want to include names that are explicitly marked
					genderMatches = item.neutral === true;
				} else if (selectedGender.value !== 'any') {
					// otherwise, we want to match the selected gender
					genderMatches = item.gender === selectedGender.value;
				}

				return styleMatches && genderMatches;
			});

			babyNameGenerator.chooseBabyName();
		},

		chooseBabyName: () => {
			const button = babyNameGenerator.nameCard.querySelector('button');

			if (!babyNameGenerator.potentialBabyNameList.length && !babyNameGenerator.checkedBabyNames.length) return;

			//REMOVE SUGGEST NEW NAME IF ONLY ONE NAME EXISTS
			if (babyNameGenerator.potentialBabyNameList.length === 1 && !babyNameGenerator.checkedBabyNames.length) {
				button.classList.add('btn--hidden');
				return babyNameGenerator.generateContent(babyNameGenerator.potentialBabyNameList[0]);
			}

			//ADD BUTTON BACK IF MORE THAN ONE NAME (PASSES GUARD)
			if (button.classList.contains('btn--hidden')) {
				button.classList.remove('btn--hidden');
			}

			//IF USER CYCLED THROUGH ALL NAMES, RESET THE LIST
			if (!babyNameGenerator.potentialBabyNameList.length && babyNameGenerator.checkedBabyNames.length) {
				babyNameGenerator.potentialBabyNameList = babyNameGenerator.checkedBabyNames;
				babyNameGenerator.checkedBabyNames = [];
			}
			//RANDOMLY RETURN A NAME OBJECT OUT OF FILTERED ARRAY
			if (babyNameGenerator.potentialBabyNameList.length) {
				const randomlyRemovedNameId = Math.floor(
					Math.random() * babyNameGenerator.potentialBabyNameList.length
				);
				const removedName = babyNameGenerator.potentialBabyNameList[randomlyRemovedNameId];
				//REMOVE NAME FROM ARRAY AND SET
				babyNameGenerator.potentialBabyNameList.splice(randomlyRemovedNameId, 1)[0];
				babyNameGenerator.generateContent(removedName);
				babyNameGenerator.checkedBabyNames.push(removedName);
				return;
			}
		},

		generateContent: nameObject => {
			const container = document.createElement('div'),
				button = babyNameGenerator.nameCard.querySelector('button'),
				currentContent = babyNameGenerator.nameCard.querySelector('div'),
				heading = `<h2>${nameObject.name} ${babyNameGenerator.babySurnameValue}</h2>`,
				origin = `<div><strong>Origin & meaning:</strong> ${nameObject.origin} ${nameObject.meaning === 'Unknown' ? nameObject.meaning : `"${nameObject.meaning}"`}</div>`,
				score = nameObject.popularityScore ? `<div><strong>${nameObject.popularityScore}</strong> most popular ${nameObject.gender}s name in 2020 in <strong>England</strong> and <strong>Wales</strong></div>` : '';

			//IF CONTENT ALREADY EXISTS, REMOVE IT
			if (currentContent) currentContent.remove();

			//SET NEW CONTENT
			container.innerHTML = `${heading}${origin}${score}`;
			babyNameGenerator.nameCard.insertBefore(container, button);

			//SHOW ANSWER
			babyNameGenerator.nameCard.parentElement.style.display = '';
			babyNameGenerator.form.style.display = 'none';
		},

		validateInputs: (fieldset, errorId) => {
			//IF NO ERROR EXISTS ALREADY
			if (fieldset.classList.contains('field-group--error')) return;

			//ADD ERROR MESSAGE ID
			fieldset.querySelector('.error-message').id = errorId;

			//SET FIELD GROUP TO ERROR CLASS
			fieldset.classList.add('field-group--error');

			//RED BORDERS
			const inputs = fieldset.querySelectorAll('input');
			inputs.forEach(input => {
				input.setAttribute('aria-invalid', true);
				input.setAttribute('aria-errormessage', errorId);
			});
		},

		setInputEventListeners: () => {
			const textInputs = babyNameGenerator.form.querySelectorAll('input[type="text"]');
			const radios = babyNameGenerator.form.querySelectorAll('input[type="radio"]');

			//ADD E LISTENER TO REMOVE ERROR ON CHANGE
			radios.forEach(radio => {
				radio.addEventListener('change', () => babyNameGenerator.removeErrorsOnFormInput(radio));
			});

			//ADD E LISTENER TO REMOVE ERROR ON USER INPUT
			textInputs.forEach(input => {
				input.addEventListener('keypress', e => {
					if (e.keyCode === 13 || e.which === 13 || e.key === 'Enter') {
						e.preventDefault();
					}
					babyNameGenerator.removeErrorsOnFormInput(input);
				});
			});
		},

		removeErrorsOnFormInput: input => {
			const fieldGroup = input.closest('.field-group');

			if (!fieldGroup.classList.contains('field-group--error')) return; //IF NO ERROR EXIT FUNCTION

			const inputs = fieldGroup.querySelectorAll('input');

			//REMOVE ERROR MESSAGE
			fieldGroup.classList.remove('field-group--error');

			//REMOVE ATTRIBUTES
			inputs.forEach(input => {
				input.removeAttribute('aria-invalid');
				input.removeAttribute('aria-errormessage');
			});
		},

		resetWidget: () => {
			const textInputs = babyNameGenerator.form.querySelectorAll('input[type="text"]'),
				radios = babyNameGenerator.form.querySelectorAll('input[type="radio"]');

			//RESET CHOSEN NAME
			babyNameGenerator.potentialBabyNameList = [];
			babyNameGenerator.checkedBabyNames = [];
			babyNameGenerator.form.style.display = '';
			babyNameGenerator.nameCard.parentElement.style.display = 'none';

			//RESET FORM
			radios.forEach(radio => {
				radio.checked = false;
			});

			textInputs.forEach(input => {
				input.value = '';
			});
		},
	};

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	babyNameGenerator.init();
});
